import { render, staticRenderFns } from "./LibraryBoard.vue?vue&type=template&id=19d461e9&"
import script from "./LibraryBoard.vue?vue&type=script&lang=js&"
export * from "./LibraryBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports